export const fetchExtraSlideList = resp => {
  return {
    type: "FETCH_EXTRA_SLIDE_LIST",
    payload: resp
  };
};

export const saveExtraSlide = resp => {
  return {
    type: "SAVE_EXTRA_SLIDE",
    payload: resp
  };
};

export const deleteExtraSlide = resp => {
  return {
    type: "DELETE_EXTRA_SLIDE",
    payload: resp
  };
};

export const setExtraSlideListPaginationPage = pageNumber => {
  return {
    type: "SET_EXTRA_SLIDES_LIST_PAGINATION_PAGE",
    pageNumber
  };
};

export const setVisibilityExtraSlide = selected => {
  return {
    type: "SET_VISIBILITY_EXTRA_SLIDE",
    selected
  };
};

export const setSearchTitleExtraSlide = title => {
  return {
    type: "SET_SEARCH_TITLE_EXTRA_SLIDE",
    title
  };
};

export const setExtraSlideList = extraSlides => {
  return {
    type: "SET_EXTRA_SLIDE_LIST",
    extraSlides
  };
};

export const setCategorySelectedItem = newSelectedItems => {
  return {
    type: "SET_CATEGORY_SELECTED_ITEM",
    newSelectedItems
  };
};

export const fetchCategoryExtraSlideList = resp => {
  return {
    type: "FETCH_CATEGORY_EXTRA_SLIDE_LIST",
    payload: resp
  };
};

export const saveCategoryExtraSlide = resp => {
  return {
    type: "SAVE_CATEGORY_EXTRA_SLIDE",
    payload: resp
  };
};

export const deleteCategoryExtraSlide = resp => {
  return {
    type: "DELETE_CATEGORY_EXTRA_SLIDE",
    payload: resp
  };
};

export const setCategoryExtraSlideList = categoryList => {
  return {
    type: "SET_CATEGORY_EXTRA_SLIDE_LIST",
    categoryList
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/extraSlideList.js